var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnderReorganization(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61816 10.0454H10.3506C11.0684 10.0454 11.5981 9.92578 11.9399 9.68652C12.2817 9.44727 12.4526 9.07129 12.4526 8.55859C12.4526 8.05078 12.2769 7.68945 11.9253 7.47461C11.5786 7.25977 11.0391 7.15234 10.3066 7.15234H9.61816V10.0454ZM9.61816 11.8911V16H7.34766V5.29199H10.4678C11.9229 5.29199 12.9995 5.55811 13.6978 6.09033C14.396 6.61768 14.7451 7.4209 14.7451 8.5C14.7451 9.12988 14.5718 9.69141 14.2251 10.1846C13.8784 10.6729 13.3877 11.0562 12.7529 11.3345C14.3643 13.7417 15.4141 15.2969 15.9023 16H13.3828L10.8267 11.8911H9.61816Z",
    fill: "#C40F11"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderReorganization);
export default __webpack_public_path__ + "static/media/under-reorganization.e8e6f0ab4f7904789b65ada83a4e313f.svg";
export { ForwardRef as ReactComponent };